import { useState, useEffect, useRef } from 'preact/hooks';

const Filter = ({
  locationTypes,
  services,
  selectedLocationTypes,
  selectedServices,
  onLocationTypeChange,
  onServiceChange,
}) => {
  const [isTypesOpen, setIsTypesOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const typesRef = useRef(null);
  const servicesRef = useRef(null);

  // click outside handler
  useEffect(() => {
    const handleClickOutside = event => {
      if (typesRef.current && !typesRef.current.contains(event.target)) {
        setIsTypesOpen(false);
      }
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setIsServicesOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="uberall-locations__filters">
      <div className="uberall-locations__filter" ref={typesRef}>
        <button
          className="uberall-locations__filter-toggle"
          type="button"
          onClick={() => setIsTypesOpen(!isTypesOpen)}
          aria-expanded={isTypesOpen}
          aria-haspopup="true"
        >
          Standortart
          {selectedLocationTypes.length > 0 && ` (${selectedLocationTypes.length})`}
          <span className={`uberall-locations__filter-icon ${isTypesOpen ? 'open' : ''}`}>▼</span>
        </button>
        {isTypesOpen && (
          <div className="uberall-locations__filter-dropdown">
            {locationTypes.length === 0 ? (
              <div className="uberall-locations__filter-empty">Keine Standortarten verfügbar</div>
            ) : (
              locationTypes.map(type => (
                <label key={type} className="uberall-locations__filter-option checkbox">
                  <input
                    type="checkbox"
                    className="powermail_checkbox"
                    checked={selectedLocationTypes.includes(type)}
                    onChange={() => onLocationTypeChange(type)}
                  />
                  <span>{type}</span>
                </label>
              ))
            )}
          </div>
        )}
      </div>

      <div className="uberall-locations__filter" ref={servicesRef}>
        <button
          className="uberall-locations__filter-toggle"
          type="button"
          onClick={() => setIsServicesOpen(!isServicesOpen)}
          aria-expanded={isServicesOpen}
          aria-haspopup="true"
        >
          Leistungen
          {selectedServices.length > 0 && ` (${selectedServices.length})`}
          <span className={`uberall-locations__filter-icon ${isServicesOpen ? 'open' : ''}`}>▼</span>
        </button>
        {isServicesOpen && (
          <div className="uberall-locations__filter-dropdown">
            {services.length === 0 ? (
              <div className="uberall-locations__filter-empty">Keine Leistungen verfügbar</div>
            ) : (
              services.map(service => (
                <label key={service} className="uberall-locations__filter-option checkbox">
                  <input
                    type="checkbox"
                    className="powermail_checkbox"
                    checked={selectedServices.includes(service)}
                    onChange={() => onServiceChange(service)}
                  />
                  <span>{service}</span>
                </label>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Filter;
